import type { FC } from "react";

import type { Language } from "@ui/components/LanguageSelector";

import { ChevronBackwardIcon } from "@jti/brand-icons/chevron-backward";

import { HeaderNavListItem } from "../HeaderNavListItem";
import { LanguagePanel } from "../LanguagePanel";
import { NavPanel } from "../NavPanel";

import styles from "../../MobileNavigation.module.scss";

type LanguageNavPanelProps = {
  panelId: string;
  isActive: boolean;
  languageLabel: string;
  languages: Language[];
  onBack: () => void;
  panelRef: (node: HTMLElement | null) => void;
  disableTransition?: boolean;
};

export const LanguageNavPanel: FC<LanguageNavPanelProps> = ({
  panelId,
  isActive,
  languageLabel,
  languages,
  onBack,
  panelRef,
  disableTransition,
}) => {
  const titleId = `${panelId}-title`;

  return (
    <NavPanel
      id={panelId}
      isActive={isActive}
      labelledById={titleId}
      disableTransition={disableTransition}
      ref={panelRef}
    >
      {" "}
      <header className={styles.panelHeader}>
        <HeaderNavListItem
          label={languageLabel}
          startIcon={ChevronBackwardIcon}
          id={titleId}
          onClick={onBack}
          hasTextEmphasized={true}
        />
      </header>
      <LanguagePanel languages={languages} />
    </NavPanel>
  );
};
